import * as z from 'zod';

export const statusQuerySchema = z.enum(['In Process', 'On Hold', 'Completed']);

type StatusQuerySchema = z.infer<typeof statusQuerySchema>;
export type StatusMutationSchema = StatusQuerySchema;

export const statusFormSchema = z.object({
  name: z.string(),
  value: statusQuerySchema,
});

type StatusFormSchema = z.infer<typeof statusFormSchema>;

export const statusOptions: StatusFormSchema[] = [
  { name: 'In Process', value: 'In Process' },
  { name: 'On Hold', value: 'On Hold' },
  { name: 'Completed', value: 'Completed' },
];

export const defaultStatus = statusOptions[0];

export function strToStatus(status: StatusQuerySchema | null): StatusFormSchema | null {
  return statusOptions.find((option) => option?.value === status) ?? null;
}

export function statusToStr(status: StatusFormSchema | null) {
  return status?.value ?? null;
}
